import styled, { css } from 'styled-components';

export const CartSummaryStyled = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 10px;

        @media ${theme.mediaQueries.queryVl} {
            flex-direction: row;
            margin-bottom: 30px;
        }
    `,
);

export const CartSummaryLeftStyled = styled.div(
    ({ theme }) => css`
        flex: 1;

        @media ${theme.mediaQueries.queryVl} {
            padding-right: 15px;
            max-width: 623px;
        }
    `,
);

export const CartSummaryRightStyled = styled.div(
    ({ theme }) => css`
        @media ${theme.mediaQueries.queryVl} {
            margin-left: 30px;
        }
    `,
);

export const FreeTransportWrapperStyled = styled.div(
    ({ theme }) => css`
        padding: 20px 35px;

        border: 5px solid ${theme.color.grayLight};
        border-radius: ${theme.radius.medium};
    `,
);

export const TelephoneContactWrapperStyled = styled.div(
    ({ theme }) => css`
        margin-top: 30px;
        display: flex;
        align-items: center;

        font-weight: 700;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            display: none;
        }
    `,
);

export const TelephoneContactIconWrapperStyled = styled.div`
    height: 100%;
    width: 25px;
    margin-left: 15px;
`;

export const TelephoneContactStyled = styled.a`
    color: inherit;
    text-decoration: none;

    &:hover {
        color: inherit;
        text-decoration: none;
    }
`;

export const OpeningHoursStyled = styled.span(
    ({ theme }) => css`
        padding-left: 10px;

        color: ${theme.color.grayDark};
        font-size: 15px;
        font-weight: 400;
    `,
);

export const CartSummaryLoadingWrapperStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
`;
